import { twMerge } from 'tailwind-merge';

// NOTE: opted to not `extend` e.g. `HTMLAttributes` because there was
// compatibility issues with the existing `onChange` prop
export interface ToggleProps {
  checked: boolean;
  onChange: (value: boolean) => void;
  className?: string;
}

const Toggle = ({ checked, onChange, className }: ToggleProps) => {
  return (
    <button
      role="switch"
      aria-checked={checked}
      className={twMerge('relative inline-flex items-center', className)}
      onClick={() => onChange(!checked)}
      aria-label={checked ? 'On' : 'Off'}
    >
      <div
        className={`peer h-7 w-12 rounded-full ${checked ? 'bg-[#240089] after:left-[calc(100%-26px)] after:border-white' : 'bg-[#E6E6E6]'} after:absolute after:left-[2px] after:top-[50%] after:h-[24px] after:w-[24px] after:-translate-y-1/2 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-['']`}
      ></div>
    </button>
  );
};

export default Toggle;
